// extracted by mini-css-extract-plugin
export var actualite = "detailsActu-module--actualite--1dcc6";
export var actualiteContentFooter = "detailsActu-module--actualite-content-footer--2e911";
export var actualiteContentFooterBack = "detailsActu-module--actualite-content-footer-back--497d1";
export var actualiteImg = "detailsActu-module--actualite-img--cde86";
export var actualiteTags = "detailsActu-module--actualite-tags--7e05c";
export var actualiteTaxo = "detailsActu-module--actualite-taxo--f96dc";
export var actualiteTitle = "detailsActu-module--actualite-title--2d7ab";
export var pageActu = "detailsActu-module--page-actu--e42b8";
export var pageActuAdditionalInfos = "detailsActu-module--page-actu-additional-infos--daab4";
export var socialPanelContainer = "detailsActu-module--social-panel-container--93bc3";